angular.module('app').config(featuresRouting);

function featuresRouting($routeProvider) {
  $routeProvider.when('/features', {
    pageTitle: 'FEATURES',
    template: '<features-page></features-page>',
    menu: 'features',
    accessPermission: 'index_feature_superadmin',
    authReq: true,
  });
}

featuresRouting.$inject = ['$routeProvider'];
